import React from "react";
import { intl } from "../../../i18n/TypedIntl";

interface Props extends React.HTMLProps<HTMLDivElement> {
  count: number;
  allCount: number;
}
export const TextFractionSpan = ({ count, allCount, ...rest }: Props) => {
  return (
    <span {...rest}>
      {count} {intl.formatMessage("outOf")} {allCount}
    </span>
  );
};
